export const GET_ORDERS = 'getOrders';
export const GET_ORDERS_EFG = 'getOrdersEfg';
export const GET_ALL = 'getAll';
export const GET_LASTUPDATE = 'getLastUpdate';
export const GET_ACTIVE_DEMANDS = 'getActiveDemands';
export const GET_PURCHASEOFFER_FOR_DEMAND_FILTERED = 'allPurchaseOffersByProductKeyVariantKey';
